import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=a144e89a&"
import script from "./OrderShow.vue?vue&type=script&lang=js&"
export * from "./OrderShow.vue?vue&type=script&lang=js&"
import style0 from "./OrderShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports